import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { applyLoan } from "../../../services/user.services";
import { IconLoader2 } from "@tabler/icons-react";

// Content data for different URL endpoints
const contentData = {
  forex: {
    title: "Forex Cards & Remittances: Save Big on Your International Payments",
    contentName: "Forex Cards & Remittances",
    description: (
      <div className="text-gray-900 text-md leading-relaxed space-y-4">
        <p>
          If you're planning to apply to universities or make payments in
          foreign currencies, using a
          <span className="font-semibold"> forex card </span>is a must. Paying
          through regular debit or credit cards comes with hefty foreign
          exchange charges—ranging from
          <span className="font-bold"> 1.5% to 3% or more</span>, plus
          additional fees. A forex card, on the other hand, helps you
          <span className="font-bold">
            {" "}
            avoid these high conversion charges{" "}
          </span>
          and makes international transactions seamless.
        </p>

        <ul className="list-disc list-inside space-y-1">
          <li>
            <span className="font-semibold">Multi-Currency Usage</span> – Pay in
            <span className="font-semibold">
              {" "}
              USD, GBP, EUR, and other currencies
            </span>{" "}
            with minimal transaction fees.
          </li>
          <li>
            <span className="font-semibold">Cost-Effective</span> – Ideal for
            application fees, tuition deposits, WES evaluations, GRE payments,
            and more.
          </li>
          <li>
            <span className="font-semibold">Online & In-Person Payments</span> –
            Use it for both digital transactions and in-store purchases abroad.
          </li>
        </ul>

        <p>
          Get your <span className="font-semibold">forex card early</span> to
          maximize savings throughout your application process!
        </p>

        <h2 className="font-bold mt-4">
          Remittances – Secure & Affordable International Transfers
        </h2>

        <p>
          When making <span className="font-semibold">large payments</span> like
          tuition fees or accommodation charges, forex cards and net banking may
          not be the best options. Instead, you'll need a{" "}
          <span className="font-semibold">
            forex intermediary—a bank, NBFC, or forex agency
          </span>
          —to handle these transactions efficiently.
        </p>

        <ul className="list-disc list-inside space-y-1">
          <li>
            <span className="font-semibold">Lower Costs</span> – Banks usually
            charge
            <span className="font-bold text-black"> ₹2–₹3 per dollar</span> over
            the exchange rate, while trusted forex agencies charge
            <span className="font-bold text-black">
              {" "}
              as low as ₹0.80–₹1 per dollar
            </span>
            , helping you save significantly.
          </li>
          <li>
            <span className="font-semibold">Reliable Transactions</span> – Not
            all forex agencies are trustworthy, so choosing the right one is
            crucial.
          </li>
        </ul>

        <p>
          Need assistance?
          <span className="font-bold text-black px-1">
            Click the button below
          </span>
          to connect with our trusted forex partners for secure, low-cost
          remittances. Let us help you
          <span className="font-bold">
            {" "}
            save money on your international payments!
          </span>
        </p>
      </div>
    ),
    buttonLabel: "Apply Now",
    partners: [
      "/images/forex/partner1.png",
      "/images/forex/partner2.png",
      "/images/forex/partner3.png",
      "/images/forex/partner4.png",
      "/images/forex/partner5.png",
    ],
  },
  "education-loan": {
    title:
      "Education Loan – Find the Best Option for Your Study Abroad Journey",
    contentName: "Education Loan",
    description: (
      <div className="text-gray-900 text-md leading-relaxed space-y-4">
        <p className="mb-4">
          Financing your education abroad is a crucial step, and choosing the
          right loan can make a significant difference. There are two major
          types of education loans available:
        </p>

        <h2 className="text-lg font-semibold mb-2">
          1. Collateral (Secured) Loans
        </h2>
        <p className="mb-2">These loans are backed by an asset, such as:</p>
        <ul className="list-disc list-inside mb-4">
          <li>
            Property (except freehold land or agricultural land in some cases)
          </li>
          <li>Fixed deposits (FDs)</li>
          <li>LIC policies and other financial assets</li>
        </ul>

        <h3 className="font-semibold mb-1">Advantages of Collateral Loans:</h3>
        <ul className="list-none mb-6">
          <li>
            ✅ <strong>Higher Loan Amount</strong> – Loan value depends on the
            asset provided.
          </li>
          <li>
            ✅ <strong>Lower Interest Rates</strong> – Usually{" "}
            <span className="font-semibold">1% to 1.5%</span> lower than
            non-collateral loans.
          </li>
        </ul>

        <h2 className="text-lg font-semibold mb-2">
          2. Non-Collateral (Unsecured) Loans
        </h2>
        <p className="mb-2">
          These loans do not require any asset as security. Instead, approval is
          based on:
        </p>
        <ul className="list-disc list-inside mb-2">
          <li>
            <strong>The financial standing of the sponsor</strong> (income,
            wealth, credit history)
          </li>
          <li>
            <strong>
              The student's academic profile and the university they are
              admitted to
            </strong>
          </li>
        </ul>
        <p className="mb-6">
          Non-collateral loans are available from various banks, NBFCs, and
          international lenders.
        </p>

        <h2 className="text-lg font-semibold mb-2">
          International Loan Options
        </h2>
        <ul className="list-disc list-inside mb-6">
          <li>
            <strong>Foreign Currency Loans</strong> – Some international lenders
            offer loans directly in{" "}
            <span className="font-semibold">USD, EUR, GBP</span>, and other
            currencies, eliminating forex conversion charges.
          </li>
          <li>
            <strong>US-Based Loans</strong> – If you're studying in the{" "}
            <span className="font-semibold">US</span> and have a{" "}
            <span className="font-semibold">sponsor in the US</span>, you can
            secure a loan there at{" "}
            <span className="font-semibold">almost half the interest rate</span>{" "}
            compared to India.
          </li>
        </ul>

        <h2 className="text-lg font-semibold mb-2">
          Why Apply Through Aara Consultancy?
        </h2>
        <ul className="list-none mb-4">
          <li>
            🔹 <strong>Lower Interest Rates</strong> – We help negotiate better
            rates than if you apply directly.
          </li>
          <li>
            🔹 <strong>Reduced Processing Fees</strong> – Save money on
            application charges.
          </li>
          <li>
            🔹 <strong>Hassle-Free Process</strong> – We handle follow-ups and
            ensure timely{" "}
            <span className="font-semibold">sanction & disbursement</span>.
          </li>
          <li>
            🔹 <strong>Multiple Loan Options</strong> – We suggest the best loan
            based on your requirements and documentation availability.
          </li>
        </ul>
        <p className="mb-6">
          <strong>Start Early!</strong> You can apply for an education loan
          before or after receiving an admit—universities can be changed later.
          <span className="font-bold text-black px-1">
            Click the button below
          </span>
          to connect with our loan advisors and secure the best education loan
          for your study abroad journey!
        </p>
      </div>
    ),
    buttonLabel: "Apply Now",
    partners: [
      "/images/education/partner1.png",
      "/images/education/partner2.png",
      "/images/education/partner3.png",
      "/images/education/partner4.png",
    ],
  },
  insurance: {
    title: "Insurance",
    contentName: "Insurance",
    description: (
      <div className="text-gray-900 text-md leading-relaxed space-y-4">
        <h2 className="text-xl font-semibold mb-4">
          Student Travel & Health Insurance – Protect Yourself While Studying
          Abroad
        </h2>

        <p className="mb-4">
          Insurance is a crucial part of your study abroad journey, ensuring you
          are covered for unexpected events. There are{" "}
          <strong>two types of insurance</strong> every student should consider:
        </p>

        <h3 className="text-lg font-semibold mb-2">1. Travel Insurance ✈️</h3>
        <ul className="list-disc list-inside mb-4">
          <li>
            <strong>Covers your journey before your course starts</strong>.
          </li>
          <li>
            Protects against{" "}
            <strong>missed flights, lost luggage, trip cancellations</strong>,
            and initial medical emergencies.
          </li>
          <li>
            <strong>Mandatory</strong> for European countries and recommended
            for all destinations.
          </li>
        </ul>

        <h3 className="text-lg font-semibold mb-2">2. Health Insurance 🏥</h3>
        <ul className="list-disc list-inside mb-2">
          <li>
            Covers <strong>medical expenses</strong> during your studies.
          </li>
          <li>
            Some countries make it <strong>compulsory</strong>, while others
            offer flexibility.
          </li>
          <li>
            <strong>University-Provided Insurance Can Be Expensive!</strong>
          </li>
        </ul>
        <ul className="list-disc list-inside pl-4 mb-6">
          <li>
            <strong>USA:</strong> Many universities offer insurance at{" "}
            <strong>high costs</strong>, but some allow waivers. We can help you
            get{" "}
            <strong>
              equivalent coverage at 25–30% of the university price
            </strong>
            .
          </li>
          <li>
            <strong>Australia:</strong> We provide approved health insurance at{" "}
            <strong>70% of the university price</strong>.
          </li>
        </ul>

        <h3 className="text-lg font-semibold mb-2">How We Help You Save?</h3>
        <ul className="list-none space-y-1 mb-6">
          <li>
            ✅ <strong>Compare & Find the Best Plans</strong> – Get{" "}
            <strong>affordable</strong> insurance options while ensuring full
            coverage.
          </li>
          <li>
            ✅ <strong>University Insurance Waivers</strong> – If your
            university allows, we help you get cheaper alternatives.
          </li>
          <li>
            ✅ <strong>Country-Specific Guidance</strong> – We provide insurance
            solutions based on your study destination's requirements.
          </li>
        </ul>

        <p className="mb-6">
          <strong>Insurance is not just an extra cost—it's a safety net</strong>{" "}
          that ensures peace of mind while you study.
          <span className="font-bold text-black px-1">
            Click the button below
          </span>
          to connect with us and get the right insurance at the best price!
        </p>
      </div>
    ),
    buttonLabel: "Apply Now",
    partners: [
      "/images/insurance/partner1.png",
      "/images/insurance/partner2.png",
      "/images/insurance/partner3.png",
      "/images/insurance/partner4.png",
      "/images/insurance/partner5.png",
    ],
  },
};

function ForexCard() {
  const { type } = useParams();
  const content = contentData[type] || contentData.forex;
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleApplyNow = async () => {
    setIsLoading(true);
    const loanData = {
      loan_type: content.contentName,
    };

    try {
      const response = await applyLoan(loanData);
      setMessage(response.status || "Loan application submitted successfully!");
    } catch (error) {
      console.error("Error applying for loan:", error);
      setMessage(
        error.response?.data?.error || "An error occurred. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen p-8 justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-2xl font-bold mb-4">{content.title}</h1>
        <div className="text-gray-700 mb-6">{content.description}</div>

        {/* <h2 className="text-lg font-semibold mb-4">Our Partners</h2>
        <div className="grid grid-cols-5 gap-4 mb-6">
          {content.partners.map((partner, index) => (
            <img
              key={index}
              src={partner}
              alt={`Partner ${index + 1}`}
              className="h-[160px] w-40 object-cover rounded"
            />
          ))}
        </div> */}

        <div className="text-center">
          <button
            className="bg-green-500 text-white py-2 px-6 rounded-lg text-lg font-semibold flex items-center justify-center mx-auto min-w-[150px]"
            onClick={handleApplyNow}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <IconLoader2 className="animate-spin mr-2" size={20} />
                Processing...
              </>
            ) : (
              content.buttonLabel
            )}
          </button>
        </div>

        {message && (
          <p
            className={`mt-4 text-lg text-center ${
              message.includes("successfully")
                ? "text-green-500"
                : "text-red-500"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
}

export default ForexCard;
